module.exports = __webpack_public_path__ + "img/open-table-rate-icon.2da3a442.png";